var PhxCheckout = (function (PhxCheckout) {
  //Import modules only for jest.
  if(typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
    const logger = require('./logger');
    Object.assign(PhxCheckout, logger)
  }
  /**
   * ThreeDSecure helper object
   */
  PhxCheckout.threeDSecureHelper = (function () {
    // Submits 3DS form with POST action to stepUpUrl
    function _postStepUpUrl(data) {
      try {
        var tdsform = document.getElementById("tds-form");
        var jwtField = document.getElementById("tds-jwt");
        // check if mandatory data exists
        // check modal url
        if (typeof data.modalUrl !== "string") {
          throw new Error("Missing modal url");
        }
        // check accessToken
        if (typeof data.accessToken !== "string") {
          throw new Error("Missing access token");
        }
        // set value of form input fields
        tdsform.action = data.modalUrl;
        jwtField.value = data.accessToken;

        PhxCheckout.logger.logEventToServer("iFrame3dsFormSubmit", { posAction: 'init' });
        // submit form
        tdsform.submit();
      } catch (e) {
        _relay3dsFailure(e);
        PhxCheckout.logger.logEventToServer("iFrame3dsFormSubmit", { posAction: 'failure', posError: e.message});
      }
    }

    // Pings back to parent
    function _ping3ds() {
      var payload = { action: "PING_3DS" };
      PhxCheckout.messenger.postMessageToParent(payload);
    }

    // Send status to parent
    function _setThreeDSecureCompleted(transactionId) {
      var payload = {
        action: "THREE_D_SECURE_COMPLETED",
        data: { transactionId: transactionId },
      };
      PhxCheckout.messenger.postMessageToParent(payload);
    }

    function _relay3dsFailure(errorData) {
      var payload = {
        action: "THREE_D_SECURE_FAILED",
        data: errorData ? (typeof errorData === 'string' ? errorData : errorData.message) : null,
      };
      PhxCheckout.messenger.postMessageToParent(payload);
    }

    return {
      postStepUpUrl: _postStepUpUrl,
      ping3ds: _ping3ds,
      setThreeDSecureCompleted: _setThreeDSecureCompleted,
      relay3dsFailure: _relay3dsFailure,
    };
  })();

  return PhxCheckout;
})(PhxCheckout || {});

if(typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
  module.exports = PhxCheckout //export it as module only for jest.
}

